import _styled from "styled-components";
const _excluded = ["className", "style", "children", "variant", "padding", "maxWidth"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
import { VARIANTS } from '../consts';
import { getContainerBodyStyle } from '../helpers';
const Body = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      className,
      style,
      children,
      variant = VARIANTS.DARK,
      padding = `${theme.spacing.XS}px ${theme.spacing.S}px`,
      maxWidth = '300px'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledDiv, _extends({
    className: className,
    ref: ref
  }, props, {
    $_css: [theme.typography.bodySmall, {
      padding,
      maxWidth,
      overflowWrap: 'break-word'
    }, getContainerBodyStyle(variant), style]
  }), children);
});
Body.displayName = 'Body';
Body.propTypes = {
  /** className */
  className: PropTypes.string,
  /** style */
  style: stylePropType,
  /** children */
  children: PropTypes.any,
  /** variants */
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
  /** padding */
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /** maxWidth */
  maxWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default Object.assign(Body, {
  VARIANTS
});
var _StyledDiv = _styled("div").withConfig({
  displayName: "Body___StyledDiv",
  componentId: "sc-5ahg19-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=Body.js.map